export default __webpack_public_path__ + "static/iso-press-top-image-98023b5844cbe70899e985e24d413d02.png";